import PropTypes from 'prop-types'
import BaseButton from "./Button.jsx"

export default function SecondaryButton({children, ...props}) {
  return (
    <BaseButton color={"secondary"} {...props}>
      {children}
    </BaseButton>
  )
}

SecondaryButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  className: PropTypes.string,
  type: PropTypes.string
}